interface Props {
    className?: string;
}

export function XFilledIcon({ className }: Props) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none">
            <path
                d="M32 0.5C14.6047 0.5 0.5 14.6047 0.5 32C0.5 49.3953 14.6047 63.5 32 63.5C49.3953 63.5 63.5 49.3953 63.5 32C63.5 14.6047 49.3953 0.5 32 0.5ZM43.6297 43.9672L38.9891 43.9461L32 35.6141L25.018 43.9391L20.3703 43.9602C20.0609 43.9602 19.8078 43.7141 19.8078 43.3977C19.8078 43.2641 19.857 43.1375 19.9414 43.032L29.0891 32.1336L19.9414 21.2422C19.8564 21.1391 19.8093 21.0101 19.8078 20.8766C19.8078 20.5672 20.0609 20.3141 20.3703 20.3141L25.018 20.3352L32 28.6672L38.982 20.3422L43.6227 20.3211C43.932 20.3211 44.1852 20.5672 44.1852 20.8836C44.1852 21.0172 44.1359 21.1438 44.0516 21.2492L34.918 32.1406L44.0586 43.0391C44.143 43.1445 44.1922 43.2711 44.1922 43.4047C44.1922 43.7141 43.9391 43.9672 43.6297 43.9672Z"
                fill="currentColor"
            />
        </svg>
    );
}
